/**
 * Embed Icons
 *
 * @see https://github.com/WordPress/gutenberg/blob/trunk/packages/block-library/src/embed/icons.js
 */

const embedYouTubeIcon = {
  foreground: '#ff0000',
  src: (
    <svg viewBox="0 0 24 24">
      <path d="M21.8 8s-.195-1.377-.795-1.984c-.76-.797-1.613-.8-2.004-.847-2.798-.203-6.996-.203-6.996-.203h-.01s-4.197 0-6.996.202c-.39.046-1.242.05-2.003.846C2.395 6.623 2.2 8 2.2 8S2 9.62 2 11.24v1.517c0 1.618.2 3.237.2 3.237s.195 1.378.795 1.985c.76.797 1.76.77 2.205.855 1.6.153 6.8.2 6.8.2s4.203-.005 7-.208c.392-.047 1.244-.05 2.005-.847.6-.607.795-1.985.795-1.985s.2-1.618.2-3.237v-1.517C22 9.62 21.8 8 21.8 8zM9.935 14.595v-5.62l5.403 2.82-5.403 2.8z" />
    </svg>
  )
};

const defaultEnvelopeIcon = (
  <svg
    id="Envelope_01"
    data-name="Envelope 01"
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="53.444"
    viewBox="0 0 75 53.444"
  >
    <g id="Icon_-_Envelope_1" data-name="Icon - Envelope 1">
      <g
        id="Group_3768"
        data-name="Group 3768"
        transform="translate(9.353 6.77)"
      >
        <path
          id="Path_61194"
          data-name="Path 61194"
          d="M78.7,67.5H23.744A5.36,5.36,0,0,1,18.4,62.161V56.1a1.336,1.336,0,0,1,2.672,0v6.057a2.625,2.625,0,0,0,2.672,2.672H78.7a2.625,2.625,0,0,0,2.672-2.672V32.944A2.625,2.625,0,0,0,78.7,30.272H23.744a2.625,2.625,0,0,0-2.672,2.672v3.741a1.336,1.336,0,1,1-2.672,0V32.944A5.36,5.36,0,0,1,23.744,27.6H78.7a5.36,5.36,0,0,1,5.344,5.344V62.071A5.38,5.38,0,0,1,78.7,67.5Z"
          transform="translate(-18.4 -27.6)"
        />
      </g>
      <g
        id="Group_3769"
        data-name="Group 3769"
        transform="translate(60.203 7.382)"
      >
        <path
          id="Path_61195"
          data-name="Path 61195"
          d="M76.835,38.72a1.27,1.27,0,0,1-1.069-.534,1.3,1.3,0,0,1,.267-1.871l10.243-7.749a1.336,1.336,0,0,1,1.6,2.138L77.636,38.453A1.243,1.243,0,0,1,76.835,38.72Z"
          transform="translate(-75.488 -28.288)"
        />
      </g>
      <g
        id="Group_3770"
        data-name="Group 3770"
        transform="translate(11.294 7.375)"
      >
        <path
          id="Path_61196"
          data-name="Path 61196"
          d="M50.616,54.04a1.243,1.243,0,0,1-.8-.267L21.043,30.614a1.329,1.329,0,0,1,1.692-2.049L50.7,51.012,64.511,40.5a1.336,1.336,0,1,1,1.6,2.138l-14.7,11.134A1.243,1.243,0,0,1,50.616,54.04Z"
          transform="translate(-20.58 -28.28)"
        />
      </g>
      <g
        id="Group_3771"
        data-name="Group 3771"
        transform="translate(11.265 33.177)"
      >
        <path
          id="Path_61197"
          data-name="Path 61197"
          d="M21.841,69.23a1.276,1.276,0,0,1-.98-.445,1.3,1.3,0,0,1,.178-1.871l11.134-9.353a1.329,1.329,0,0,1,1.692,2.049L22.732,68.874A1.144,1.144,0,0,1,21.841,69.23Z"
          transform="translate(-20.547 -57.247)"
        />
      </g>
      <g
        id="Group_3772"
        data-name="Group 3772"
        transform="translate(26.704 25.457)"
      >
        <path
          id="Path_61198"
          data-name="Path 61198"
          d="M39.234,55.278a1.643,1.643,0,0,1-1.069-.445,1.381,1.381,0,0,1,.178-1.871l4.9-4.1a1.329,1.329,0,0,1,1.692,2.049l-4.9,4.1A1.089,1.089,0,0,1,39.234,55.278Z"
          transform="translate(-37.88 -48.58)"
        />
      </g>
      <g
        id="Group_3773"
        data-name="Group 3773"
        transform="translate(51.529 23.827)"
      >
        <path
          id="Path_61199"
          data-name="Path 61199"
          d="M86.014,68.083a1.34,1.34,0,0,1-.98-.356L66.151,49.021a1.323,1.323,0,0,1,1.871-1.871L86.9,65.856a1.292,1.292,0,0,1,0,1.871A1.361,1.361,0,0,1,86.014,68.083Z"
          transform="translate(-65.75 -46.75)"
        />
      </g>
      <g
        id="Group_3774"
        data-name="Group 3774"
        transform="translate(0 18.884)"
      >
        <path
          id="Path_61200"
          data-name="Path 61200"
          d="M28.743,43.872H9.236a1.336,1.336,0,0,1,0-2.672H28.654a1.37,1.37,0,0,1,1.336,1.336A1.294,1.294,0,0,1,28.743,43.872Z"
          transform="translate(-7.9 -41.2)"
        />
      </g>
      <g
        id="Group_3775"
        data-name="Group 3775"
        transform="translate(11.223 50.772)"
      >
        <path
          id="Path_61201"
          data-name="Path 61201"
          d="M41.343,79.672H21.836a1.336,1.336,0,0,1,0-2.672H41.254a1.37,1.37,0,0,1,1.336,1.336A1.294,1.294,0,0,1,41.343,79.672Z"
          transform="translate(-20.5 -77)"
        />
      </g>
      <g
        id="Group_3776"
        data-name="Group 3776"
        transform="translate(28.771)"
      >
        <path
          id="Path_61202"
          data-name="Path 61202"
          d="M60.954,22.672H41.536a1.336,1.336,0,1,1,0-2.672H60.954a1.336,1.336,0,1,1,0,2.672Z"
          transform="translate(-40.2 -20)"
        />
      </g>
      <g
        id="Group_3777"
        data-name="Group 3777"
        transform="translate(0 24.673)"
      >
        <path
          id="Path_61203"
          data-name="Path 61203"
          d="M25.269,50.372H9.236a1.336,1.336,0,0,1,0-2.672H25.18a1.37,1.37,0,0,1,1.336,1.336A1.294,1.294,0,0,1,25.269,50.372Z"
          transform="translate(-7.9 -47.7)"
        />
      </g>
      <g
        id="Group_3778"
        data-name="Group 3778"
        transform="translate(0 30.463)"
      >
        <path
          id="Path_61204"
          data-name="Path 61204"
          d="M22.241,56.872h-13a1.336,1.336,0,1,1,0-2.672h13a1.336,1.336,0,0,1,0,2.672Z"
          transform="translate(-7.9 -54.2)"
        />
      </g>
    </g>
  </svg>
);

const starEnvelopeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74.213"
    height="73.605"
    viewBox="0 0 74.213 73.605"
  >
    <g
      id="Icon_-_Envelope_2"
      data-name="Icon - Envelope 2"
      transform="translate(2.106 1.5)"
    >
      <path
        id="Path_61205"
        data-name="Path 61205"
        d="M214.946,151.843l3.652,7.3,7.913,1.065-5.782,5.63,1.369,7.913-7.152-3.8-7,3.8,1.369-7.913-5.782-5.63,7.913-1.065Z"
        transform="translate(-179.338 -134.952)"
        fill="none"
        stroke="#000"
        strokeWidth="3"
      />
      <path
        id="Path_61206"
        data-name="Path 61206"
        d="M102.307,225.072v42.761h-70V225.072"
        transform="translate(-32.307 -197.833)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61207"
        data-name="Path 61207"
        d="M102.307,225.072l-35,27.543-35-27.543"
        transform="translate(-32.307 -197.833)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61208"
        data-name="Path 61208"
        d="M32.308,398.219l27.239-21.3"
        transform="translate(-32.308 -328.219)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61209"
        data-name="Path 61209"
        d="M334.916,376.915l27.239,21.3"
        transform="translate(-292.155 -328.219)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61210"
        data-name="Path 61210"
        d="M464.144,176.612l8.978,7"
        transform="translate(-403.122 -156.22)"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61211"
        data-name="Path 61211"
        d="M213.226,39.765l9.435-7.457,9.587,7.608"
        transform="translate(-187.661 -32.308)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61212"
        data-name="Path 61212"
        d="M32.308,184.537l8.978-6.848"
        transform="translate(-32.308 -157.146)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        id="Path_61213"
        data-name="Path 61213"
        d="M96.92,112.478V86.152h51.739v26.326"
        transform="translate(-87.79 -78.543)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </g>
  </svg>
);

const circleEnvelopeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 75 75">
    <g id="Icon_-_Circle_Envelope" data-name="Icon - Circle Envelope" transform="translate(-69.998)">
      <path id="Path_61222" data-name="Path 61222" d="M107.5,0a37.5,37.5,0,1,0,26.516,10.984A37.5,37.5,0,0,0,107.5,0ZM124.26,24.525,107.5,38.489,90.736,24.525Zm1.987,24.337a1.5,1.5,0,0,1-1.628,1.612H90.375a1.455,1.455,0,0,1-1.628-1.5V26.641l3.75,3.1,13.95,11.625h0a1.447,1.447,0,0,0,2.107,0l17.167-14.31.525-.4V48.862Z" />
    </g>
  </svg>
);

const paperPlaneIcon = (
  <svg id="Icon_-_Paper_Plane" data-name="Icon - Paper Plane" xmlns="http://www.w3.org/2000/svg" width="75" height="56.4" viewBox="0 0 75 56.4">
    <path id="Path_61217" data-name="Path 61217" d="M92.393,131.17a1.785,1.785,0,0,0-1.094,1.25,1.485,1.485,0,0,0,.625,1.563l11.25,7.656a4.455,4.455,0,0,1,2.343-2.969l44.375-23.437Z" transform="translate(-91.258 -111.019)" />
    <path id="Path_61218" data-name="Path 61218" d="M304.183,190.886a2.217,2.217,0,0,0,.937.312h.469a1.409,1.409,0,0,0,.937-.937l20.312-47.03-44.687,32.811Z" transform="translate(-254.456 -134.956)" />
    <path id="Path_61219" data-name="Path 61219" d="M254.613,86.967a1.493,1.493,0,0,0-2.031-.625L195.708,116.5a1.592,1.592,0,0,0-.781,1.25,2.324,2.324,0,0,0,.625,1.406l8.281,5.625a1.563,1.563,0,0,0,1.875,0L254.3,89a1.481,1.481,0,0,0,.313-2.031Z" transform="translate(-179.886 -86.191)" />
    <path id="Path_61220" data-name="Path 61220" d="M276.77,403.949l4.531-4.375-3.281-2.188Z" transform="translate(-249.855 -352.236)" />
    <path id="Path_61221" data-name="Path 61221" d="M208.554,346.522l-6.094-4.062,4.062,17.969a1.522,1.522,0,0,0,1.563,1.25,1.683,1.683,0,0,0,1.563-1.25l2.5-12.968h-.781a7.475,7.475,0,0,1-2.813-.938Z" transform="translate(-186.326 -305.279)" />
  </svg>
);

const arrowRightIcon = (
  <svg
    className="arrow-right"
    xmlns="http://www.w3.org/2000/svg"
    width="7.755"
    height="11.995"
    viewBox="0 0 7.755 11.995"
  >
    <path
      id="arrow"
      d="M244.609,4456.377l5.344,4.685-5.344,4.49"
      transform="translate(-243.198 -4454.966)"
      fill="none"
      stroke="currentColor"
      // This causes an error in the admin. Not sure how to fix it without a migration. strokeLinecapp misspelling does nothing.
      // eslint-disable-next-line react/no-unknown-property
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

const arrowLeftCarouselIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.244"
    height="27.812"
    viewBox="0 0 19.244 27.812"
  >
    <path
      d="M1.7,27.812l17.544-13.6V13.6L1.632,0,0,2.108l15.368,11.9L.068,25.84Z"
      fill="currentColor"
      stroke="currentColor"
      transform="translate(19.244 27.812) rotate(180)"
    />
  </svg>
);

const arrowRightCarouselIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.244"
    height="27.812"
    viewBox="0 0 19.244 27.812"
  >
    <path
      d="M1.7,0,19.244,13.6v.612L1.632,27.812,0,25.7,15.368,13.8.068,1.972Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

const closeButtonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.421"
    height="20.421"
    viewBox="0 0 20.421 20.421"
  >
    <g
      id="Close_button"
      data-name="Close button"
      transform="translate(1.768 1.768)"
    >
      <path
        id="Stroke_1"
        data-name="Stroke 1"
        d="M0,16.886,16.886,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        id="Stroke_3"
        data-name="Stroke 3"
        d="M0,0,16.886,16.886"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </g>
  </svg>
);

const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.999"
    height="21.999"
    viewBox="0 0 21.999 21.999"
  >
    <g id="icon-search-white" transform="translate(-450.156 -1184.001)">
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M20.063,22h0L15.5,17.434a9.515,9.515,0,0,1-5.734,1.937h-.2A9.625,9.625,0,0,1,0,9.686V9.567A9.626,9.626,0,0,1,9.624,0H9.8a9.638,9.638,0,0,1,9.566,9.685A9.507,9.507,0,0,1,17.434,15.5L22,20.063,20.064,22ZM9.549,2.768A6.859,6.859,0,0,0,2.768,9.686v.137A6.852,6.852,0,0,0,9.618,16.6h.205A6.859,6.859,0,0,0,16.6,9.686V9.549a6.851,6.851,0,0,0-6.85-6.782H9.549Z"
        transform="translate(450.155 1184)"
        fill="currentColor"
      />
    </g>
  </svg>
);

const mobileMenuIcon = (
  <svg
    className="pointer-events-none"
    xmlns="http://www.w3.org/2000/svg"
    width="37.6"
    height="27.2"
    viewBox="0 0 37.6 27.2"
  >
    <g
      id="Mobile_Hamburger"
      data-name="Mobile Hamburger"
      transform="translate(0.749 0.6)"
    >
      <path
        id="Stroke_1"
        data-name="Stroke 1"
        d="M0,.65H35.1"
        transform="translate(0.501)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        id="Stroke_3"
        data-name="Stroke 3"
        d="M0,.5H17.1"
        transform="translate(18.501 12.5)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        id="Stroke_5"
        data-name="Stroke 5"
        d="M0,.65H35.1"
        transform="translate(0.501 24.7)"
        fill="none"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </g>
  </svg>
);

const filterIcon = (
  <svg
    id="filter_icon"
    data-name="filter icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15.381"
    height="13.5"
    viewBox="0 0 15.381 13.5"
  >
    <rect
      id="Rectangle_1615"
      data-name="Rectangle 1615"
      width="15.381"
      height="1"
      rx="0.25"
      transform="translate(0 1.25)"
      fill="#fff"
    />
    <rect
      id="Rectangle_1616"
      data-name="Rectangle 1616"
      width="15.381"
      height="1"
      rx="0.25"
      transform="translate(0 6.25)"
      fill="#fff"
    />
    <rect
      id="Rectangle_1617"
      data-name="Rectangle 1617"
      width="15.381"
      height="1"
      rx="0.25"
      transform="translate(0 11.25)"
      fill="#fff"
    />
    <circle
      id="Ellipse_7"
      data-name="Ellipse 7"
      cx="1.75"
      cy="1.75"
      r="1.75"
      transform="translate(10.278)"
      fill="#fff"
    />
    <circle
      id="Ellipse_8"
      data-name="Ellipse 8"
      cx="1.75"
      cy="1.75"
      r="1.75"
      transform="translate(2.028 5)"
      fill="#fff"
    />
    <circle
      id="Ellipse_9"
      data-name="Ellipse 9"
      cx="1.75"
      cy="1.75"
      r="1.75"
      transform="translate(6.778 10)"
      fill="#fff"
    />
  </svg>
);

const authorShapeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="135"
    height="135"
    viewBox="0 0 189 189"
  >
    <path
      fill="#F6F6F6"
      fillRule="evenodd"
      stroke="#DDD"
      d="M141.361148,22.5 C150.134737,22.5 153.323279,23.3958393 156.532658,25.1122336 C159.703494,26.8080154 162.191985,29.2965062 163.887766,32.4673424 C165.604161,35.6767207 166.5,38.8652632 166.5,47.638852 L166.5,47.638852 L166.5,141.361148 C166.5,150.134737 165.604161,153.323279 163.887766,156.532658 C162.191985,159.703494 159.703494,162.191985 156.532658,163.887766 C153.38391,165.571735 150.255345,166.465892 141.850621,166.499046 L141.850621,166.499046 L47.1571407,166.499079 C38.7471619,166.466539 35.6172878,165.572376 32.4673424,163.887766 C29.2965062,162.191985 26.8080154,159.703494 25.1122336,156.532658 C23.4282651,153.38391 22.5341081,150.255345 22.5009543,141.850621 L22.5009543,141.850621 L22.5009212,47.1571407 C22.5334606,38.7471619 23.4276244,35.6172878 25.1122336,32.4673424 C26.8080154,29.2965062 29.2965062,26.8080154 32.4673424,25.1122336 C35.6767207,23.3958393 38.8652632,22.5 47.638852,22.5 L47.638852,22.5 Z"
      transform="rotate(45 94.5 94.5)"
    />
  </svg>
);

const applePodcastsIcon = () => (
  <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.1 21">
    <path
      fill="currentColor"
      d="M11.51,12.6c-.41-.43-1.12-.71-1.97-.71s-1.56,.28-1.97,.71c-.21,.22-.33,.45-.36,.78-.07,.63-.03,1.18,.04,2.05,.07,.83,.21,1.94,.38,3.07,.12,.8,.23,1.24,.32,1.55,.15,.5,.71,.94,1.58,.94s1.44-.44,1.58-.94c.09-.31,.19-.75,.32-1.55,.18-1.13,.31-2.24,.38-3.07,.07-.87,.11-1.42,.04-2.05-.04-.33-.15-.56-.36-.78Zm-4.19-3.83c0,1.23,.99,2.22,2.22,2.22s2.22-.99,2.22-2.22-.99-2.22-2.22-2.22-2.22,.99-2.22,2.22ZM9.52,0C4.32,.01,.07,4.23,0,9.43c-.05,4.21,2.64,7.81,6.39,9.13,.09,.03,.18-.04,.17-.14-.05-.33-.1-.66-.14-.98-.02-.11-.09-.21-.19-.26-2.97-1.3-5.04-4.27-5-7.72C1.27,4.95,4.96,1.26,9.48,1.22c4.62-.04,8.4,3.71,8.4,8.33,0,3.41-2.06,6.35-5.01,7.63-.11,.05-.18,.14-.19,.26-.04,.32-.09,.65-.14,.98-.01,.1,.08,.17,.17,.14,3.72-1.31,6.39-4.85,6.39-9.01C19.1,4.27,14.8-.02,9.52,0Zm-.17,4.38c2.95-.11,5.38,2.25,5.38,5.17,0,1.49-.63,2.83-1.64,3.77-.09,.08-.13,.19-.12,.31,.02,.36,.01,.7-.01,1.09,0,.1,.11,.17,.2,.11,1.69-1.15,2.8-3.09,2.8-5.28,0-3.61-3.01-6.53-6.65-6.39-3.38,.13-6.1,2.92-6.14,6.31-.03,2.23,1.09,4.2,2.8,5.37,.09,.06,.2,0,.2-.11-.02-.39-.03-.74-.01-1.09,0-.12-.04-.23-.12-.31-1.04-.97-1.67-2.37-1.63-3.91,.07-2.71,2.26-4.93,4.97-5.03Z"
    />
  </svg>
);

const pinterestIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M9.04,21.54C10,21.83 10.97,22 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z"
      fill="currentColor"
    />
  </svg>
);

const stitcherIcon = () => (
  <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 8.86">
    <rect x="12.86" y="6.76" width="3.84" height="1.25" />
    <rect x="8.58" y="6.76" width="3.84" height="2.1" />
    <rect x="4.3" y="6.76" width="3.84" height="1.25" />
    <rect y="6.76" width="3.86" height="1.74" />
    <rect x="17.14" y="6.76" width="3.86" height=".68" />
    <rect x="12.86" width="3.84" height="2.3" />
    <rect x="8.58" y="1.15" width="3.84" height="1.15" />
    <rect x="4.3" y=".51" width="3.84" height="1.79" />
    <rect y="1.68" width="3.86" height=".62" />
    <rect x="17.14" y="1.38" width="3.86" height=".92" />
    <path d="M10.9,3.71c.39,0,.58,.29,.58,.3v.03l.63-.38v-.02s-.22-.59-1.22-.59-1.56,.57-1.56,1.48c0,.98,.55,1.52,1.56,1.52s1.2-.57,1.21-.59v-.02l-.61-.37v.02s-.23,.3-.59,.3h0c-.49,0-.76-.31-.76-.85s.25-.81,.76-.81Z" />
    <polygon points="17.85 3.7 17.85 3.06 15.54 3.06 15.54 6 15.54 6 17.85 6 17.85 5.37 16.33 5.37 16.33 4.83 17.25 4.83 17.25 4.23 16.33 4.23 16.33 3.7 17.85 3.7" />
    <polygon points="15.13 6 15.13 3.06 14.34 3.06 14.34 4.23 13.21 4.23 13.21 3.06 12.42 3.06 12.42 6 13.21 6 13.21 4.87 14.34 4.87 14.34 6 15.13 6" />
    <path d="M20.87,4.07c0-.65-.44-1.01-1.23-1.01h-1.38v2.94h.8v-.86h.52l.48,.86h.93l-.63-1.02c.34-.18,.51-.49,.51-.91Zm-1.23,.43h-.59v-.8h.59c.31,0,.47,.13,.47,.4s-.15,.4-.47,.4Z" />
    <polygon points="5.12 3.06 2.6 3.06 2.6 3.71 3.46 3.71 3.46 6 4.25 6 4.25 3.71 5.12 3.71 5.12 3.06" />
    <polygon points="9.27 3.06 6.75 3.06 6.75 3.71 7.61 3.71 7.61 6 8.41 6 8.41 3.71 9.27 3.71 9.27 3.06" />
    <path d="M1.13,6.03s.03,0,.04,0c.85-.02,1.27-.31,1.27-.91,0-.65-.56-.8-1-.92-.28-.08-.52-.15-.52-.31,0-.04,0-.18,.3-.18,.24,0,.46,.11,.57,.3v.03l.63-.39v-.02c-.19-.35-.65-.59-1.16-.59C.51,3.02,.09,3.34,.09,3.92c0,.62,.54,.77,.98,.89,.29,.08,.54,.15,.54,.33,0,.1-.05,.21-.44,.21-.55,0-.91-.33-.91-.34l-.03-.03-.23,.72H.02s.44,.33,1.11,.33Z" />
    <rect x="5.54" y="3.06" width=".79" height="2.94" />
  </svg>
);

const tuneInIcon = () => (
  <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 21">
    <path d="M9.14,9.77v.91c0,.1-.08,.18-.18,.18h-1.14c-.05,0-.09,.04-.09,.09v4.82c0,.1-.08,.18-.18,.18h-.91c-.1,0-.18-.08-.18-.18v-4.82c0-.05-.04-.09-.09-.09h-1.14c-.1,0-.18-.08-.18-.18v-.91c0-.1,.08-.18,.18-.18h3.73c.1,0,.18,.08,.18,.18m5-.18h-.92c-.1,0-.18,.08-.18,.18v4.27c0,.4-.33,.73-.88,.73s-.86-.33-.86-.73v-4.27c0-.1-.08-.18-.18-.18h-.92c-.1,0-.18,.08-.18,.18v4.27c0,1.1,.91,2.01,2.14,2.01s2.16-.91,2.16-2.01v-4.27c0-.1-.08-.18-.18-.18m5.13,0h-.91c-.1,0-.18,.08-.18,.18v3.42c0,.05-.06,.07-.08,.02l-1.25-3.45c-.03-.08-.09-.16-.23-.16h-1.08c-.1,0-.18,.08-.18,.18v6c0,.1,.08,.18,.18,.18h.91c.1,0,.18-.08,.18-.18v-3.14c0-.05,.06-.07,.08-.02l1.24,3.19c.03,.07,.09,.15,.25,.15h1.07c.1,0,.18-.08,.18-.18v-6c0-.1-.08-.18-.18-.18m4.71,5.09h-2.15c-.05,0-.09-.04-.09-.09v-1.09c0-.05,.04-.09,.09-.09h2.04c.1,0,.18-.08,.18-.18v-.91c0-.1-.08-.18-.18-.18h-2.04c-.05,0-.09-.04-.09-.09v-1.09c0-.05,.04-.09,.09-.09h2.12c.1,0,.18-.08,.18-.18v-.91c0-.1-.08-.18-.18-.18h-3.3c-.1,0-.18,.08-.18,.18v6c0,.1,.08,.18,.18,.18h3.34c.1,0,.18-.08,.18-.18v-.91c0-.1-.08-.18-.18-.18M45.73,1.18V15.27c0,.38-.3,.68-.68,.68h-15.68v3.86c0,.38-.31,.68-.68,.68H.95c-.38,0-.68-.31-.68-.68V5.73c0-.38,.3-.68,.68-.68H28V1.18c0-.38,.3-.68,.68-.68h16.36c.38,0,.68,.31,.68,.68M28,6.41H1.75c-.06,0-.11,.05-.11,.11v12.5c0,.06,.05,.11,.11,.11H27.89c.06,0,.11-.05,.11-.11V6.41Zm8.14,3.95c0-.1-.08-.18-.18-.18h-.77c-.05,0-.09-.04-.09-.09v-3.73c0-.05,.04-.09,.09-.09h.68c.1,0,.18-.08,.18-.18v-.86c0-.1-.08-.18-.18-.18h-2.82c-.1,0-.18,.08-.18,.18v.86c0,.1,.08,.18,.18,.18h.68c.05,0,.09,.04,.09,.09v3.73c0,.05-.04,.09-.09,.09h-.77c-.1,0-.18,.08-.18,.18v.86c0,.1,.08,.18,.18,.18h3c.1,0,.18-.08,.18-.18v-.86Zm5.1-5.14c0-.1-.08-.18-.18-.18h-.91c-.1,0-.18,.08-.18,.18v3.42c0,.05-.06,.07-.08,.02l-1.25-3.45c-.03-.08-.09-.16-.23-.16h-1.08c-.1,0-.18,.08-.18,.18v6c0,.1,.08,.18,.18,.18h.91c.1,0,.18-.08,.18-.18v-3.14c0-.05,.06-.07,.08-.02l1.24,3.19c.03,.07,.09,.15,.25,.15h1.07c.1,0,.18-.08,.18-.18V5.23Z" />
  </svg>
);
const tiktokIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM385.62,232.382c-27.184,0-53.634-8.822-74-23.75l-.162,101.5a92.457,92.457,0,1,1-80.178-91.721v49.845a43.657,43.657,0,1,0,31.288,41.876V109.333h51.275a71.773,71.773,0,0,0,71.774,71.773Z"
    />
  </svg>
);

const instagramIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M314.757,147.525H197.243a49.717,49.717,0,0,0-49.718,49.718V314.757a49.718,49.718,0,0,0,49.718,49.718H314.757a49.718,49.718,0,0,0,49.717-49.718V197.243A49.717,49.717,0,0,0,314.757,147.525ZM256,324.391A68.391,68.391,0,1,1,324.391,256,68.391,68.391,0,0,1,256,324.391ZM327.242,201.58a16.271,16.271,0,1,1,16.27-16.271A16.271,16.271,0,0,1,327.242,201.58Z"
    />
    <path
      fill="currentColor"
      d="M256,211.545A44.455,44.455,0,1,0,300.455,256,44.455,44.455,0,0,0,256,211.545Z"
    />
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM389.333,312.5A76.836,76.836,0,0,1,312.5,389.333H199.5A76.837,76.837,0,0,1,122.666,312.5V199.5A76.836,76.836,0,0,1,199.5,122.667H312.5A76.836,76.836,0,0,1,389.333,199.5Z"
    />
  </svg>
);

const facebookIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0Zm67.59,153.428s-26.194-2.064-36.513,1.746c-17.056,6.3-17.462,21.034-17.462,35.084v28.694h52.149l-7.62,54.888H269.615V409.333h-58.9V273.84H161.744V218.952h48.974V172.4c0-49.292,37.942-67.151,60.563-69.294s52.309,4.286,52.309,4.286Z"
    />
  </svg>
);

const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="30"
    height="30"
  >
    <path
      d="M15.77,14.61l5.17,7.4h-2.12l-4.22-6.04h0s-.62-.89-.62-.89l-4.93-7.05h2.12l3.98,5.69.62.89ZM30,15c0,8.28-6.72,15-15,15S0,23.28,0,15,6.72,0,15,0s15,6.72,15,15ZM22.83,23l-6.34-9.23h0l5.83-6.77h-1.38l-5.06,5.88-4.04-5.88h-4.66l6.11,8.9-6.11,7.1h1.38l5.35-6.21,4.27,6.21h4.66Z"
      fill="currentColor"
      strokeWidth="0"
    />
  </svg>
);

const linkedInIcon = (
  <svg
    data-name="Layer 1"
    id="Layer_1"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM183.435,382.667H126.381V203.653h57.054ZM154.908,180.208a32.1,32.1,0,1,1,32.1-32.1A32.1,32.1,0,0,1,154.908,180.208ZM389.2,382.667h-56l0-97.882c0-4.973.785-37.949-27.219-37.949a30.948,30.948,0,0,0-25.681,12.576,39.134,39.134,0,0,0-7.818,23.8v99.451H216.55V203.653h53.216v25.124c12.737-19.541,28.789-26.694,44.578-29.573,28.027-5.11,74.851,11.952,74.851,62.9Z"
    />
  </svg>
);

const snapchatIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM397.237,340.541c-7.869,4.563-25.949,8.762-31.439,8.762s-5.82,6.024-5.49,10.222-1.683,10.405-13.395,7.666-25.123-4.713-36.014,1.826c-7.9,4.746-25.4,24.1-54.9,24.1s-46.994-19.349-54.9-24.1c-10.891-6.539-24.3-4.563-36.015-1.826s-13.725-3.468-13.394-7.666,0-10.222-5.491-10.222-23.57-4.2-31.439-8.762-6.99-13.143,1.372-13.143,16.745-2.738,37.607-21.905,21.776-38.333,21.776-40.7-7.48-9.371-20.5-11.683a25.22,25.22,0,0,1-13.906-8.059,9.243,9.243,0,0,1,1.3-13.781,13.256,13.256,0,0,1,14.1-.92c10.069,5.417,22.624,3.958,22.624,3.958a359.927,359.927,0,0,1-2.343-43.809c.366-21.9,15.737-71.19,79.2-71.19s78.836,49.286,79.2,71.19a359.927,359.927,0,0,1-2.343,43.809s12.554,1.459,22.623-3.958a13.256,13.256,0,0,1,14.1.92,9.243,9.243,0,0,1,1.3,13.781,25.216,25.216,0,0,1-13.906,8.059c-13.016,2.312-20.5,9.31-20.5,11.683s.916,21.539,21.777,40.7S387.5,327.4,395.865,327.4,405.106,335.977,397.237,340.541Z"
    />
  </svg>
);

const pinterestIcon2 = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM366.418,272.746c-22.052,57.336-63.216,67.9-89.3,67.9s-41.807-21.384-41.807-21.384-7.484,38.758-14.327,56.132c-3.894,9.891-9.847,20.2-14.255,27.263a8.526,8.526,0,0,1-.806,1.282A48.2,48.2,0,0,1,194.3,414.782a5.429,5.429,0,0,1-8.346-3.827c-.456-3.4-.97-8.238-1.448-15.045-.846-9.238-1.307-21.459,1.084-30.544,4.009-15.236,24.591-106.252,24.591-106.252-17.107-46.243,8.554-71.9,30.473-72.973s25.126,28.066,21.116,40.9-13.231,45.307-14.835,50.92,4.01,38.091,37.288,30.473,46.912-58.138,46.912-93.021-22.053-66.691-74.176-67.493-78.587,38.224-85,66.29,6.014,47.847,9.757,53.059,3.207,6.683,2.673,11.895-2,17.241-9.623,17.508-23.256-13.9-29.269-25.927c-19.69-39.381-6.934-85.372,21.539-117.275,36.457-40.849,107.555-47.58,154.478-22.257C372.032,158.475,388.471,215.41,366.418,272.746Z"
    />
  </svg>
);

const youtubeIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <path
      fill="currentColor"
      d="M256,0c141.29,0 256,114.71 256,256c0,141.29 -114.71,256 -256,256c-141.29,0 -256,-114.71 -256,-256c0,-141.29 114.71,-256 256,-256Zm153.315,178.978c-3.68,-13.769 -14.522,-24.61 -28.29,-28.29c-24.958,-6.688 -125.025,-6.688 -125.025,-6.688c0,0 -100.067,0 -125.025,6.688c-13.765,3.68 -24.61,14.521 -28.29,28.29c-6.685,24.955 -6.685,77.024 -6.685,77.024c0,0 0,52.067 6.685,77.02c3.68,13.769 14.525,24.614 28.29,28.293c24.958,6.685 125.025,6.685 125.025,6.685c0,0 100.067,0 125.025,-6.685c13.768,-3.679 24.61,-14.524 28.29,-28.293c6.685,-24.953 6.685,-77.02 6.685,-77.02c0,0 0,-52.069 -6.685,-77.024Zm-185.316,125.025l0,-96.002l83.137,48.001l-83.137,48.001Z"
    />
  </svg>
);

const goodreadsIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
  >
    <circle cx="256" cy="256" fill="currentColor" r="256" />
    <path
      d="M348.7,306.4V101.1H314v32.2h-0.5c-6.6-12.5-15.8-21.7-27.6-28.1c-12-6.1-24.8-9.2-39.1-9.2  c-19.4,0-35.5,3.6-48.8,11c-13.3,7.4-24,16.9-32.2,28.1c-8.2,11.5-13.8,24.3-17.4,38.3c-3.3,14.1-5.1,27.6-5.1,40.9  c0,15.3,2,29.9,6.1,43.5c4.3,13.8,10.5,25.8,18.9,36c8.4,10.2,18.9,18.4,31.2,24.5c12.5,6.1,27.1,9.2,44,9.2  c14.3,0,28.1-3.3,40.9-10c12.8-6.4,22.5-16.6,28.9-30.4h0.8V302c0,12.3-1.3,23.8-3.6,34.3c-2.6,10.2-6.6,19.2-12,26.6  c-5.4,7.4-12.5,13-20.7,17.4c-8.4,4.1-18.7,6.1-30.9,6.1c-6.1,0-12.3-0.5-18.9-1.8c-6.6-1.3-12.8-3.6-18.7-6.4  c-5.6-2.8-10.2-6.6-14.1-11.2c-4.1-4.6-6.1-10.2-6.4-16.9h-36.8c0.5,12,3.6,22.2,9.5,30.7c5.9,8.4,13,15.3,22,20.4  c8.7,5.1,18.7,8.9,29.4,11.2c10.7,2.3,21.5,3.6,31.9,3.6c35.8,0,62.1-9.2,78.7-27.3C340.3,370.5,348.7,342.9,348.7,306.4  L348.7,306.4z M245.5,295.4c-12,0-22.2-2.6-30.4-7.7c-7.9-4.9-14.6-11.5-19.4-19.9c-4.9-8.2-8.4-17.4-10.5-27.3  c-2.1-10.2-3.1-20.2-3.1-30.4c0-10.7,1.3-21,3.8-30.7c2.3-10,6.4-18.7,11.8-26.1c5.4-7.7,12-13.5,20.5-18.1  c8.4-4.3,18.7-6.6,30.4-6.6c11.5,0,21.5,2.3,29.4,6.9c8.2,4.6,14.8,10.7,19.7,18.4c5.1,7.7,8.9,16.4,11.2,25.8  c2.3,9.7,3.3,19.2,3.3,29.1c0,10.5-1.3,20.7-3.6,31.2c-2.6,10.5-6.4,19.7-11.5,27.9c-5.1,8.4-12,15.1-20.7,19.9  C268,292.8,257.7,295.4,245.5,295.4L245.5,295.4z"
      id="goodreads-g"
    />
  </svg>
);

const blueskyIcon = (
  <svg
    width="30"
    height="30"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <path
      fill="currentColor"
      d="M15,0C6.72,0,0,6.72,0,15s6.72,15,15,15,15-6.72,15-15S23.28,0,15,0ZM22.98,14.72c-.6,2.16-2.8,2.7-4.76,2.37,3.42.58,4.29,2.51,2.41,4.43-3.57,3.66-5.12-.92-5.52-2.09-.07-.21-.11-.32-.11-.23,0-.09-.03.02-.11.23-.4,1.17-1.96,5.75-5.52,2.09-1.88-1.93-1.01-3.85,2.41-4.43-1.95.33-4.15-.22-4.76-2.37-.17-.62-.47-4.44-.47-4.95,0-2.58,2.26-1.77,3.66-.72,1.94,1.45,4.02,4.4,4.79,5.98.76-1.58,2.85-4.53,4.79-5.98,1.4-1.05,3.66-1.86,3.66.72,0,.52-.3,4.33-.47,4.95Z"
    />
  </svg>
);

const threadsIcon = (
  <svg
    width="30"
    height="30"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
  >
    <path
      fill="currentColor"
      d="M30,15c0,8.28-6.72,15-15,15S0,23.28,0,15,6.72,0,15,0s15,6.72,15,15ZM15.13,23.62h0c2.29-.02,3.9-.6,5.23-1.9,1.74-1.7,1.69-3.84,1.11-5.15-.41-.94-1.2-1.7-2.27-2.21-.08-.03-.15-.07-.23-.1-.14-2.45-1.5-3.86-3.8-3.87h-.03c-1.37,0-2.52.58-3.22,1.62l1.26.85c.52-.78,1.35-.95,1.96-.95h.02c.76,0,1.33.22,1.7.64.27.31.45.73.54,1.26-.67-.11-1.4-.14-2.17-.1-1.05.06-1.94.38-2.58.93-.66.57-1,1.36-.96,2.21.05.88.5,1.64,1.26,2.13.65.42,1.48.62,2.34.58,1.14-.06,2.04-.5,2.68-1.29.48-.59.78-1.38.92-2.35.55.32.95.75,1.17,1.26.38.87.4,2.29-.78,3.45-1.04,1.02-2.28,1.46-4.17,1.47-2.09-.01-3.67-.67-4.7-1.95-.96-1.2-1.46-2.93-1.48-5.15.02-2.22.52-3.95,1.48-5.15,1.03-1.28,2.61-1.94,4.7-1.95,3.17.02,5.18,1.48,5.97,4.32l1.47-.41c-.47-1.68-1.32-3-2.52-3.93-1.28-.99-2.93-1.49-4.91-1.51h-.01c-2.57.02-4.55.87-5.88,2.52-1.18,1.47-1.79,3.52-1.81,6.1h0c.02,2.58.63,4.63,1.81,6.11,1.33,1.66,3.31,2.5,5.88,2.52h0ZM17.45,15.38c-.19,2.28-1.34,2.62-2.22,2.67-.96.05-1.95-.37-2-1.27-.05-.86.78-1.47,2.1-1.54.18-.01.36-.02.53-.02.57,0,1.11.05,1.59.16Z"
    />
  </svg>
);

const infoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g fill="#fff" stroke="#000" strokeWidth="2">
      <circle cx="15" cy="15" r="15" stroke="none" />
      <circle cx="15" cy="15" r="14" fill="none" />
    </g>
    <path
      d="M24.192,16.832V8.71l-3.93.786v1.31H22.1v6.026l-2.1.524v1.31h6.288v-1.31Zm-1.037-9.7a1.582,1.582,0,0,0,1.561-1.582,1.6,1.6,0,0,0-1.561-1.562,1.535,1.535,0,0,0-1.583,1.562A1.518,1.518,0,0,0,23.155,7.136Z"
      transform="translate(-7.869 3.029)"
    />
  </svg>
);

const shareIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.077"
    height="29"
    viewBox="0 0 20.077 29"
  >
    <path
      fill="currentColor"
      d="M16.021,1a1.115,1.115,0,0,0-.771.327L10.788,5.788a1.115,1.115,0,1,0,1.577,1.577l2.557-2.558V18.846a1.115,1.115,0,1,0,2.231,0V4.808l2.558,2.558a1.115,1.115,0,1,0,1.577-1.577L16.827,1.327A1.115,1.115,0,0,0,16.021,1ZM9.346,9.923A3.363,3.363,0,0,0,6,13.269V26.654A3.363,3.363,0,0,0,9.346,30H22.731a3.363,3.363,0,0,0,3.346-3.346V13.269a3.363,3.363,0,0,0-3.346-3.346H20.5v2.231h2.231a1.1,1.1,0,0,1,1.115,1.115V26.654a1.1,1.1,0,0,1-1.115,1.115H9.346a1.1,1.1,0,0,1-1.115-1.115V13.269a1.1,1.1,0,0,1,1.115-1.115h2.231V9.923Z"
      transform="translate(-6 -1)"
    />
  </svg>
);

const shareArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 26"
    width="30"
    height="30"
  >
    <g id="Group-5" transform="translate(2.000000, 3.000000)">
      <path
        fill="currentColor"
        id="Fill-1"
        d="M14.8,12.6c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l3.7-3.7l-3.5-3.4 c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l4.2,4.1c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-4.4,4.4 C15.4,12.6,15.1,12.6,14.8,12.6"
      />
      <path
        fill="currentColor"
        id="Fill-3"
        d="M7,22.8c-0.6,0-1-0.4-1-1v-7.4c0-5,3.2-8.2,8.2-8.2h2.9c0.6,0,1,0.4,1,1s-0.4,1-1,1h-2.9 c-3.8,0-6.2,2.4-6.2,6.2v7.4C8,22.4,7.6,22.8,7,22.8"
      />
    </g>
  </svg>
);

const playButton = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
  >
    <circle cx="22" cy="22" r="22" />
    <path
      d="M264.992,214.867V200.076l14.012,7.4Z"
      transform="translate(-247.997 -185.472)"
      fill="#fff"
    />
  </svg>
);

const pauseButton = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
  >
    <circle cx="22" cy="22" r="22" />
    <g transform="translate(1)">
      <rect
        width="3"
        height="16"
        transform="translate(15 14)"
        fill="#fff"
      />
      <rect
        width="3"
        height="16"
        transform="translate(24 14)"
        fill="#fff"
      />
    </g>
  </svg>
);

const smsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
  >
    <g id="sms" transform="translate(-0.371 0.233)">
      <circle
        id="Ellipse_14"
        data-name="Ellipse 14"
        cx="19"
        cy="19"
        r="19"
        transform="translate(0.371 -0.233)"
      />
      <path
        id="icon-sms"
        d="M4.881,4A2.881,2.881,0,0,0,2,6.881v8.642A2.881,2.881,0,0,0,4.881,18.4H6.7a2.724,2.724,0,0,1-1.585,2.183.36.36,0,0,0,.231.682A5.839,5.839,0,0,0,10.116,18.4h7.727a2.881,2.881,0,0,0,2.881-2.881V6.881A2.881,2.881,0,0,0,17.843,4Zm2.16,5.761A1.44,1.44,0,1,1,5.6,11.2,1.44,1.44,0,0,1,7.041,9.761Zm4.321,0a1.44,1.44,0,1,1-1.44,1.44A1.44,1.44,0,0,1,11.362,9.761Zm4.321,0a1.44,1.44,0,1,1-1.44,1.44A1.44,1.44,0,0,1,15.683,9.761Z"
        transform="translate(8.01 7.126)"
        fill="#fff"
      />
    </g>
  </svg>
);

const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path
      id="icon-copy"
      d="M4.2,2A2.2,2.2,0,0,0,2,4.2V18.5a1.1,1.1,0,1,0,2.2,0V4.2H18.5a1.1,1.1,0,1,0,0-2.2ZM8.6,6.4A2.2,2.2,0,0,0,6.4,8.6V21.8A2.2,2.2,0,0,0,8.6,24H21.8A2.2,2.2,0,0,0,24,21.8V8.6a2.2,2.2,0,0,0-2.2-2.2Zm0,2.2H21.8V21.8H8.6Z"
      transform="translate(-2 -2)"
    />
  </svg>
);
const downloadIcon = (
  <svg
    id="download"
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
  >
    <circle id="Ellipse_15" data-name="Ellipse 15" cx="19" cy="19" r="19" />
    <path
      id="icon-downloading"
      d="M14.961,5.978a.748.748,0,0,0-.736.758V17.394L12.51,15.679a.748.748,0,1,0-1.057,1.057l2.991,2.991a.748.748,0,0,0,1.057,0l2.991-2.991a.748.748,0,1,0-1.057-1.057L15.72,17.394V6.737a.748.748,0,0,0-.759-.758ZM6.736,18.441A.748.748,0,0,0,6,19.2v1.994a2.753,2.753,0,0,0,2.742,2.742H21.2a2.753,2.753,0,0,0,2.742-2.742V19.2a.748.748,0,1,0-1.5,0v1.994A1.235,1.235,0,0,1,21.2,22.439H8.742A1.235,1.235,0,0,1,7.5,21.193V19.2a.748.748,0,0,0-.759-.758Z"
      transform="translate(4.027 4.044)"
      fill="#fff"
    />
  </svg>
);
const mailIcon = (
  <svg
    id="mail"
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
  >
    <circle id="Ellipse_13" data-name="Ellipse 13" cx="19" cy="19" r="19" />
    <path
      id="icon-envelope"
      d="M2.1,6l8.062,7.524a1.221,1.221,0,0,0,1.661,0L19.883,6ZM1,6.928V18.844H20.979V6.928l-8.185,7.64a2.654,2.654,0,0,1-3.61,0Z"
      transform="translate(8.01 6.578)"
      fill="#fff"
    />
  </svg>
);

const prhaLogoColor = (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 41">
    <g id="PRHA-Logo-Color">
      <g id="Headphones">
        <path d="m3.9,31.38h2.98v-14.93c0-.07.02-.14.02-.21,0-6.44,5.2-11.68,11.59-11.68s11.58,5.24,11.58,11.68c0,.1.01.19.03.29v14.85h2.98c2.08,0,3.76-1.74,3.76-3.89v-7.78c0-1.77-1.15-3.27-2.72-3.74-.14-8.55-7.1-15.47-15.64-15.47S2.99,7.42,2.85,15.98c-1.56.47-2.71,1.96-2.71,3.73v7.78c0,2.15,1.68,3.89,3.76,3.89h0Zm0,0" />
      </g>
      <g id="Book">
        <path d="m24.59,37.73v-1.38h-4.61v3.11h1.01c.84-1.05,2.14-1.73,3.59-1.73" />
        <path d="m17.12,39.46h1.01v-3.11h-4.61v1.38c1.45,0,2.75.68,3.59,1.73" />
        <path d="m28.83,37.73c.43-2.1,2.29-3.69,4.52-3.69s4.09,1.58,4.52,3.69h-9.03Z" />
        <path d="m.25,37.73c.43-2.1,2.29-3.69,4.52-3.69s4.09,1.58,4.52,3.69H.25Z" />
        <path d="m33.34,37.73v-3.69h-10.66c-1.61,0-2.98.95-3.63,2.3-.65-1.36-2.02-2.3-3.63-2.3h0s-10.66,0-10.66,0v3.69h11.98v.46c0,1.27,1.03,2.3,2.3,2.3s2.3-1.03,2.3-2.3v-.46h11.98Z" />
      </g>
      <g id="Audiowaves">
        <path
          d="m12.99,27.85c0-.53-.54-.95-1.22-.95h-.18c-.67,0-1.21.43-1.21.95v2.78c0,.53.54.95,1.21.95h.18c.67,0,1.22-.43,1.22-.95v-2.78Zm0,0"
          fill="#fa6400"
        />
        <path
          d="m16.35,25.02c0-.67-.54-1.22-1.21-1.22h-.18c-.67,0-1.21.54-1.21,1.22v5.34c0,.67.54,1.21,1.21,1.21h.18c.67,0,1.21-.54,1.21-1.21v-5.34Zm0,0"
          fill="#fa6400"
        />
        <path
          d="m19.71,23.21c0-.67-.54-1.22-1.22-1.22h-.18c-.67,0-1.22.54-1.22,1.22v7.14c0,.67.54,1.21,1.22,1.21h.18c.67,0,1.22-.54,1.22-1.21v-7.14Zm0,0"
          fill="#fa6400"
        />
        <path
          d="m21.68,17.31h.18c.67,0,1.22.54,1.22,1.22v11.83c0,.67-.54,1.21-1.21,1.21h-.18c-.67,0-1.22-.54-1.22-1.22v-11.83c0-.67.54-1.22,1.22-1.22Z"
          fill="#fa6400"
        />
        <path
          d="m26.5,25.02c0-.67-.54-1.22-1.22-1.22h-.18c-.67,0-1.21.54-1.21,1.22v5.34c0,.67.54,1.21,1.21,1.21h.18c.67,0,1.22-.54,1.22-1.21v-5.34Zm0,0"
          fill="#fa6400"
        />
      </g>
    </g>
  </svg>
);

const prhLogoBlack = (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 41">
    <g id="PRHA-Logo-Color">
      <g id="Headphones">
        <path d="m3.9,31.38h2.98v-14.93c0-.07.02-.14.02-.21,0-6.44,5.2-11.68,11.59-11.68s11.58,5.24,11.58,11.68c0,.1.01.19.03.29v14.85h2.98c2.08,0,3.76-1.74,3.76-3.89v-7.78c0-1.77-1.15-3.27-2.72-3.74-.14-8.55-7.1-15.47-15.64-15.47S2.99,7.42,2.85,15.98c-1.56.47-2.71,1.96-2.71,3.73v7.78c0,2.15,1.68,3.89,3.76,3.89h0Zm0,0" />
      </g>
      <g id="Book">
        <path d="m24.59,37.73v-1.38h-4.61v3.11h1.01c.84-1.05,2.14-1.73,3.59-1.73" />
        <path d="m17.12,39.46h1.01v-3.11h-4.61v1.38c1.45,0,2.75.68,3.59,1.73" />
        <path d="m28.83,37.73c.43-2.1,2.29-3.69,4.52-3.69s4.09,1.58,4.52,3.69h-9.03Z" />
        <path d="m.25,37.73c.43-2.1,2.29-3.69,4.52-3.69s4.09,1.58,4.52,3.69H.25Z" />
        <path d="m33.34,37.73v-3.69h-10.66c-1.61,0-2.98.95-3.63,2.3-.65-1.36-2.02-2.3-3.63-2.3h0s-10.66,0-10.66,0v3.69h11.98v.46c0,1.27,1.03,2.3,2.3,2.3s2.3-1.03,2.3-2.3v-.46h11.98Z" />
      </g>
      <g id="Audiowaves">
        <path d="m12.99,27.85c0-.53-.54-.95-1.22-.95h-.18c-.67,0-1.21.43-1.21.95v2.78c0,.53.54.95,1.21.95h.18c.67,0,1.22-.43,1.22-.95v-2.78Zm0,0" />
        <path d="m16.35,25.02c0-.67-.54-1.22-1.21-1.22h-.18c-.67,0-1.21.54-1.21,1.22v5.34c0,.67.54,1.21,1.21,1.21h.18c.67,0,1.21-.54,1.21-1.21v-5.34Zm0,0" />
        <path d="m19.71,23.21c0-.67-.54-1.22-1.22-1.22h-.18c-.67,0-1.22.54-1.22,1.22v7.14c0,.67.54,1.21,1.22,1.21h.18c.67,0,1.22-.54,1.22-1.21v-7.14Zm0,0" />
        <path d="m21.68,17.31h.18c.67,0,1.22.54,1.22,1.22v11.83c0,.67-.54,1.21-1.21,1.21h-.18c-.67,0-1.22-.54-1.22-1.22v-11.83c0-.67.54-1.22,1.22-1.22Z" />
        <path d="m26.5,25.02c0-.67-.54-1.22-1.22-1.22h-.18c-.67,0-1.21.54-1.21,1.22v5.34c0,.67.54,1.21,1.21,1.21h.18c.67,0,1.22-.54,1.22-1.21v-5.34Zm0,0" />
      </g>
    </g>
  </svg>
);
const checkCircle = (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"></path></svg>
);

export {
  applePodcastsIcon,
  arrowLeftCarouselIcon,
  arrowRightCarouselIcon,
  arrowRightIcon,
  authorShapeIcon,
  checkCircle,
  closeButtonIcon,
  circleEnvelopeIcon,
  copyIcon,
  defaultEnvelopeIcon,
  downloadIcon,
  embedYouTubeIcon,
  facebookIcon,
  filterIcon,
  goodreadsIcon,
  infoIcon,
  instagramIcon,
  linkedInIcon,
  mailIcon,
  mobileMenuIcon,
  paperPlaneIcon,
  pauseButton,
  pinterestIcon,
  pinterestIcon2,
  playButton,
  prhLogoBlack,
  prhaLogoColor,
  searchIcon,
  shareArrowIcon,
  shareIcon,
  smsIcon,
  snapchatIcon,
  starEnvelopeIcon,
  stitcherIcon,
  tiktokIcon,
  tuneInIcon,
  twitterIcon,
  youtubeIcon,
  blueskyIcon,
  threadsIcon
};
